<template>
  <v-dialog v-model="dialogError" max-width="800px" persistent>
  <v-card>
    <v-card-title>
      <v-container class="text-center">
        <v-row>
          <v-col sm="12">
            <span class="headline">Błąd</span>
          </v-col>
        </v-row>
      </v-container>
    </v-card-title>
    <v-card-text>
      <v-divider></v-divider>
      <v-container class="text-center">
        <v-row>
          <v-col sm="12">
            <v-icon class="red--text" x-large>warning</v-icon>
          </v-col>
          <v-col sm="12">
            Wygląda na to, że konto ZOOM nie zostało poprawnie podpięte do konta w Unikadrze. Skontaktuj się z Dziekanatem.
          </v-col>
          <v-col sm="12">
            <v-btn color="primary" rounded @click="$emit('closedDialog')">Powrót do listy wszystkich spotkań online</v-btn>
          </v-col>
        </v-row>
      </v-container>
    </v-card-text>
  </v-card>
  </v-dialog>
</template>

<script>
export default {
  data: () => ({

  }),
  props: [
    'dialogError'
  ]
}
</script>

<style scoped>

</style>
